import React from "react";
import Layout from "../components/Layout";

import ContactForm from "../components/contactForm";

const pageDescription =
  "Virtual Horse Racing Nights for your pub / venue / party!";
const pageTitle = "Track Night: Virtual Horse Race Night Game";

function InPersonGames(ctx) {
  return (
    <Layout
      canonical="https://www.track-night.com/in-person-games"
      brand={ctx.brand}
      showHeaderLinks={true}
      ogDescription={pageDescription}
      ogTitle={pageTitle}
    >
      <div className="container">
        <div className="section">
          <h1 className="title">
            Race Nights at home... At your sports club? In the pub?
          </h1>
          <div className="columns">
            <div className="column">
              <p>
                <strong>
                  Looking for a fun alternative to your weekly pub quiz?
                </strong>
              </p>
              <p>
                We built Track Night to play over zoom while everyone was stuck
                in their houses, but things have re-opened again (and we
                couldn&apos;t be happier to be back out there!)
              </p>
              <p>
                Quite a few people have been in touch to tell us they have
                played the game in person, and it&apos;s even more fun than when
                they played on a video chat.
              </p>
              <p>
                Just get the shared screen up on your big TV, and play as you
                normally would. Turns out it is quite a lot of fun when everyone
                is in the same room cheering on their horses.
              </p>
              <p>
                <strong>
                  Give us a shout if you&apos;d like more information on running
                  a Track Night Event at your venue.
                </strong>
              </p>
            </div>
            <div className="column">
              <img src="pub.jpg" alt="In Person Horse Racing Events" />
            </div>
          </div>
          <br />
          <br />
          <ContactForm subject="In person games" />
        </div>
      </div>
      <style jsx>{`
        h1 {
          padding-bottom: 0.5em;
        }
        h2 {
          padding-bottom: 0.5em;
        }
      `}</style>
    </Layout>
  );
}

export default InPersonGames;
